export enum ViewportSizes {
  SM_MAX = 991,
  XS_MAX = 767,
}
